var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3C3.448 3 3 3.448 3 4V8C3 8.552 3.448 9 4 9H8C8.552 9 9 8.552 9 8V4C9 3.448 8.552 3 8 3H4ZM11 3V5H13V3H11ZM16 3C15.448 3 15 3.448 15 4V8C15 8.552 15.448 9 16 9H20C20.552 9 21 8.552 21 8V4C21 3.448 20.552 3 20 3H16ZM5 5H7V7H5V5ZM17 5H19V7H17V5ZM11 7V9H13V7H11ZM3 11V13H5V11H3ZM7 11V13H9V11H7ZM11 11V13H13V11H11ZM13 13V15H15V13H13ZM15 13H17V11H15V13ZM17 13V15H19V13H17ZM19 13H21V11H19V13ZM19 15V17H21V15H19ZM19 17H17V19H19V17ZM19 19V21H21V19H19ZM17 19H15V21H17V19ZM15 19V17H13V19H15ZM13 19H11V21H13V19ZM13 17V15H11V17H13ZM15 17H17V15H15V17ZM4 15C3.448 15 3 15.448 3 16V20C3 20.552 3.448 21 4 21H8C8.552 21 9 20.552 9 20V16C9 15.448 8.552 15 8 15H4ZM5 17H7V19H5V17Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQrCode);
export default __webpack_public_path__ + "static/media/ic_qr_code.0b80fd92f258bdcd6cce867b72afa7f7.svg";
export { ForwardRef as ReactComponent };